/*
 *		Copyright (c) 2011-2020 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Session')
    .factory('AccountResource', ['$resource', 'AccountInterceptor',
        function ($resource, AccountInterceptor) {
            return $resource('/account/:action', {}, {
                get: {
                    method: 'GET',
                    isArray: false,
                    interceptor: AccountInterceptor
                },
                quotaConfiguration: {
                    method: 'GET',
                    params: {
                        action: 'quota_configuration'
                    },
                    isArray: false
                },
                changeLanguage: {
                    method: 'PUT',
                    transformRequest: function (data) {
                        return JSON.stringify({locale: data.locale});
                    }
                },
                updateDetails: {
                    method: 'PUT',
                    transformRequest: function (data) {
                        return JSON.stringify({name: data.name});
                    }
                },
                updateQuotaNotification: {
                    method: 'PUT',
                    params: {
                        action: 'quota_notification',
                        quota_notification_enabled: '@notification_enabled',
                        notification_period: '@notification_period',
                        notification_percentage: '@notification_percentage'
                    },
                    transformRequest: function (_data) {
                        return JSON.stringify({});
                    }
                },
                purge: {
                    method: 'POST',
                    params: {action: 'purge'},
                    transformRequest: function (data) {
                        return angular.toJson({
                            purge_setting: data['purge_setting'],
                            purge_amount: data['purge_now_amount']
                        });
                    }
                },
                updateProactivePurging: {
                    method: 'PUT',
                    params: {action: 'proactive_purge'},
                    transformRequest: function (data) {
                        return angular.toJson({
                            auto_purge_enabled: data['purge_proactively'],
                            auto_purge: data['purge_proactively_amount']
                        });
                    }
                }
            });
        }
    ]);
